export default __webpack_public_path__ + "static/media/SiroLaserBlue.2a5bebde.png";